import { gql } from '@apollo/client';

const CREATE_REFERRING_PHYSICIAN_MUTATION = gql`
  mutation createReferringPhysician($userInfo: ReferringInput!, $facility: ID!) {
    createReferringPhysician(userInfo: $userInfo, facility: $facility) {
      isSuccess
      message
      user {
        id
        firstName
        lastName
        contact {
          phone1
          nightPhone
          fax
        }
        email
        canLogin
        npi
      }
    }
  }
`;

export default CREATE_REFERRING_PHYSICIAN_MUTATION;
